// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/" + chunkId + "." + chunkId + "." + {"4050":"48772fd6","4774":"c1383c32","8732":"1a132b92","9086":"963f27a7"}[chunkId] + ".css";
};